import capitalize from './capitalize'

const toCamelCase = string => {
  const parts = string.split('-')
  const converted = parts.map((part, i) => (i ? capitalize(part) : part))
  return converted.join('')
}

export default toCamelCase
